export default __webpack_public_path__ + "static/media/ic_type_program.0ad74384.svg";